/**
 * Points MapLibre at a worker the build actually emits.
 *
 * MapLibre 6 derives its worker URL from a template string at runtime, which Vite cannot see,
 * so a production build ships no worker and every GeoJSON or vector source stalls. Bundling it
 * with `?worker&url` also inlines the worker's own import of `maplibre-gl-shared.mjs`.
 * Imported once, for its side effect, from `main.tsx`.
 */
import { setWorkerUrl } from 'maplibre-gl';
import workerUrl from 'maplibre-gl/dist/maplibre-gl-worker.mjs?worker&url';

setWorkerUrl(workerUrl);
